'use strict';

import EmptyRouterView from '../../../app/views/EmptyRouterView.vue';

export const eventAnglerRoutes = [
  {
    path: 'anglers',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.angler.list',
        props: true,
        component: () => import('../views/AnglerListView.vue'),
      },
    ],
  },
];

export const eventManageAnglerRoutes = [
  {
    path: 'anglers',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'event.manage.angler.list',
        props: true,
        component: () => import('../views/ManageAnglerListView.vue'),
      },
      {
        path: 'add',
        name: 'event.manage.angler.add',
        props: true,
        component: () => import('../views/ManageAnglerAddView.vue'),
      },
      {
          path: ':anglerId',
          component: EmptyRouterView,
          props: true,
          children: [
            {
              path: 'edit',
              name: 'event.manage.angler.edit',
              props: true,
              component: () => import('../views/ManageAnglerEditView.vue'),
            },
          ],
        },
    ],
  },
];
